<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="loadData()">刷新</el-button>
            </div>
            <div class="header-right">
                <el-input v-model="filterParams.user_nick" placeholder="请输入用户昵称" class="header-input" @change="loadData(1)"></el-input>
                <el-input v-model="filterParams.user_phone" placeholder="请输入手机号码" class="header-input" @change="loadData(1)"></el-input>
                <el-input v-model="filterParams.product_name" placeholder="请输入商品名称" class="header-input" @change="loadData(1)"></el-input>
                <el-input v-model="filterParams.course_name" placeholder="请输入课程名称" class="header-input" @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号" width="70">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column label="头像" width="120">
                <template slot-scope="scope">
                    <el-image style="width: 50px; height: 50px;" :src="scope.row.userImage" fit="cover"></el-image>
                </template>
            </el-table-column>
            <el-table-column prop="userNick" label="用户名称" width="200">
                <template slot-scope="scope">
                    <div>{{ scope.row.userNick }}<br />{{ scope.row.userPhone }}</div>
                </template>
            </el-table-column>
            <el-table-column label="发送时间" width="220">
                <template slot-scope="scope">
                    <div>{{ convertToDate(scope.row.messageDate) }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="messageBody" label="消息内容"></el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"
import uploadMixin from "@/mixins/upload-mixin.js"
import imageMixin from "@/mixins/image-mixin.js"

export default {
    mixins: [verifyMixin, listMixin, uploadMixin, imageMixin],
    data: function () {
        return {
        }
    },
    methods: {

    },
    created: async function () {
        this.tag = "MESSAGE";
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
@import "@/assets/style/upload-style.less";
</style>